<div class="helper-container">
  <!-- boton volver-->
  <div class="button-back-container">
    <ion-col size="3">
      <app-back-button
        (clicked)="mainVolverButton()"
        [isDisabled]="isFormsButtonsDisabled"
        [text]="'Volver'"
      >
      </app-back-button>
    </ion-col>
  </div>
  <!-- titulo -->
  <header class="header-container">
    <div class="title-helper font-weight-700">¿Deseas revocar tu ahorro mensual?</div>
  </header>

  <!-- textos informativos-->
  <section class="mt-28 info-text-container">
    <div class="helper-subtitle">
      {{infoText.FIRST}}
    </div>
    <div class="helper-subtitle mt-24">
      {{infoText.SECOND}}
    </div>
    <div class="helper-subtitle mt-24">
      {{infoText.THIRD}}
    </div>
  </section>

  <section class="mt-40 info-text-container">
    <div class="second-title-helper font-weight-700">Notificación a tu empleador</div>
    <div class="mt-16 helper-subtitle">
      {{infoText.FOURTH}}
    </div>
  </section>

  <!-- input correo-->
  <section class="mt-28">
    <ion-grid class="ion-no-margin ion-no-padding">
      <ion-row [formGroup]="mailForm" class="ion-no-margin ion-no-padding">
        <ion-col size="12" class="ion-no-margin ion-no-padding">
          <div>
            <app-outline-input
              type="email"
              formControlName="email"
              label="Ingresa el correo de tu empleador"
              errorMessage="Por favor, ingresa un correo para notificarle"
              (ionChange)="handleMailInputChange()"
              [isPassword]="false"
              [isReadOnly]="isSpinnerVisible"
            >
            </app-outline-input>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </section>

  <!-- botones-->
  <section>
    <ion-row
      class="container-buttons-modal ion-justify-content-between ion-wrap-reverse"
    >
      <ion-button
          class="cancel-subscription-button ion-justify-content-center"
          [class.on-focus-button-secondary]="isFocusButtonSecondary"
          (ionFocus)="focusButtonSecondary()"
          (ionBlur)="focusButtonSecondary()"
          (click)="salir()"
          (keypress)="true"
          [disabled]="isFormsButtonsDisabled"
          >Salir</ion-button
        >
      <ion-button
        class="stop-subscription-button ion-no-margin ion-no-padding"
        (click)="stopSubscription()"
        (keypress)="true"
        [disabled]="isStopSubscriptionButtonDisabled"
        id="apv-modal-detencion-detener"
        >
          <ion-label>Revocar</ion-label>
          <ion-spinner
          class="ml-24"
          name="circular"
          slot="end"
          color="ffffffff"
          *ngIf="isSpinnerVisible"
          >
      </ion-spinner>
      </ion-button
      >
    </ion-row>
  </section>
</div>
